export const ALFRESCOLINK = 'alfrescolink';
